// src/components/Product/ProductCard/DynamicAddToCartButton.jsx

'use client';

import { useState } from 'react';
import dynamic from 'next/dynamic';


const AddToCartButton = dynamic(() => import('./AddToCartButton'), {
  loading: () => <button className='pill-small'>...</button>,
  ssr: false,
});


export default function DynamicAddToCartButton({ productObj, lang, category }) {

  const [loadComponent, setLoadComponent] = useState(false);

  const handleClick = () => setLoadComponent(true);

  if (loadComponent) {
    return <AddToCartButton productObj={productObj} lang={lang} category={category} />
  }

  return <button className='pill-small' onClick={handleClick} aria-label={`Add ${productObj.title || 'product'} to cart`}>Add to Cart</button>
}
